import { ActionTree, ActionContext } from 'vuex'

import {
  fetchBootcampsBySchedule,
  fetchBootcampById,
  registerForBootcampById,
} from '../../../models/bootcamps'
import { BootcampsState } from './state'
import { Bootcamp } from '../../types'
import { state } from '../app/state'

const actions: ActionTree<BootcampsState, {}> = {
  getCurrentBootcamps: async (context: ActionContext<BootcampsState, {}>) => {
    try {
      const bootcamps: Array<Bootcamp> = await fetchBootcampsBySchedule()
      context.commit('CURRENT_BOOTCAMPS', bootcamps)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },
  getBootcampById: async (
    context: ActionContext<BootcampsState, {}>,
    id: string
  ) => {
    try {
      const bootcamp: Bootcamp = await fetchBootcampById(id)
      context.commit('SELECTED_BOOTCAMP_UPDATED', bootcamp)
      return bootcamp
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
      throw error
    }
  },
  registerForBootcamp: async (
    context: ActionContext<BootcampsState, {}>,
    id: string
  ) => {
    try {
      const bootcamp: Bootcamp = await registerForBootcampById(id)
      await context.dispatch('getCurrentBootcamps')
      context.dispatch('app/setNotification', 'Registration successful!', {
        root: true,
      })
      return bootcamp
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
      throw error
    }
  },
}

export default actions
